import { appInfo, useSupportInfo, useSystemInfo } from "./useSystemInfo";

export const useFeedbackSystemInfo = () => {
    const { user, seller, browser, os, userAgent, currentUrl, resolution } = useSystemInfo();
    const { fullStorySessionUrl, sumoLogSessionId } = useSupportInfo();
    return {
        seller,
        user,
        os,
        appInfo,
        browser,
        userAgent,
        currentUrl,
        fullStorySessionUrl,
        sumoLogSessionId,
        window: resolution.window,
        desktop: resolution.desktop,
        native: resolution.native,
    };
};
